package com.eladfinish.bible.contest.screens.search.mvi

import com.eladfinish.bible.contest.screens.search.suggestions.AutocompleteSuggestion
import kotlinx.collections.immutable.ImmutableList

/**
 * What the results page shows instead of the results while the user types. [Hidden] while a
 * search runs and after it, until the user edits the expression again.
 */
sealed interface AutocompleteUiState {

    data object Hidden : AutocompleteUiState

    /** The user is typing: expressions that start with what is in the field. May be empty. */
    data class ForPrefix(
        val prefix: String,
        val suggestions: ImmutableList<AutocompleteSuggestion>,
    ) : AutocompleteUiState
}
